import React from "react";
import Form from "../forms/form";
import { FaCheckCircle } from "react-icons/fa";
import { IoIosCloseCircle } from "react-icons/io";
import MyCountdown from "../parts/countdown";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

function Formats({formatsData}) {

    return (
        formatsData ?
            formatsData.map((item, index) => (
                <>

                    <section id="formats" className="pb-20" key={index}>
                        <div className="container max-w-screen-lg w-[90%] lg:w-3/4 mx-auto bg-gray-100 rounded-2xl overflow-hidden border-2 border-[#E7E9EC]">

                            {
                                item.format.map((item, index) => (
                                    <div className="grid grid-col-1 lg:grid-cols-2 gap-x-[30px]" key={index}>
                                        <div className="p-8">
                                            <ScrollAnimation animateIn="animate__fadeInUp"><h6 className="bg-[#F3FF80] w-max px-3 py-1 mb-4 rounded-2xl">Формати участі</h6></ScrollAnimation>
                                            <ScrollAnimation animateIn="animate__fadeInUp"><h3 className="mb-6 text-3xl uppercase">У пакет входить</h3></ScrollAnimation>
                                            <div>
                                                <ScrollAnimation animateIn="animate__fadeInUp"><ul>
                                                    {item.format_items.map((item, index) => (
                                                        <li className="flex flex-wrap my-3" key={index}>{item.forat_checkbox ? <FaCheckCircle className="text-blue-700 text-[20px] w-[20px] mr-[10px]" /> : <IoIosCloseCircle className="text-red-600" />} <span className="w-[calc(100%-30px)]">{item.forat_item}</span></li>
                                                    ))}
                                                </ul></ScrollAnimation>
                                            </div>
                                        </div>
                                        <div className="bg-white p-8">
                                            <MyCountdown />
                                            <Form nameform="form_uchast_intext_done" />
                                        </div>
                                    </div>
                                ))
                            }


                        </div>
                    </section>
        </>)) : ''
    )
}

export default Formats